import { environment } from './environment/environment';

export const apiBaseUrl = environment.apiBaseUrl;
export const amBaseUrl = environment.amBaseUrl;
export const versionInfo = environment.versionInfo;
export const isProdMode = environment.production;
export const apiRoots = {
  machine: 'machineAsset',
  tooling: 'toolingAsset',
  plant: 'plantAsset',
  group: 'groupAsset',
  picture: 'picture',
  document: 'document',
  machineTask: '/machineTask',
  machineHistory: '/machineHistory',
  toolingTask: '/toolingTask',
  toolingHistory: '/toolingTaskHistory',
  machineOverview: '/machineOverview',
  toolingOverview: '/toolingOverview',
  machineKpi: '/MachineOverview/kpi',
  toolingKpi: '/ToolingOverview/kpi',
};
